import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:max-w-[calc(100vw-2rem)] group-[.toaster]:break-words group-[.toaster]:[overflow-wrap:anywhere]",
          title: "group-[.toast]:break-words group-[.toast]:[overflow-wrap:anywhere]",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:break-words group-[.toast]:[overflow-wrap:anywhere]",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
